var _title, _g;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgExit = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "48px",
    height: "48px",
    viewBox: "0 0 48 48",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "Exit")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon/solid/exit",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.6470588,23.5 L22.5924265,23.5 C21.9566087,23.5 21.4411765,23.9477153 21.4411765,24.5 C21.4411765,25.0522847 21.9566087,25.5 22.5924265,25.5 L30.6470588,25.5 L30.6470588,41 C30.6470588,41.5522847 30.1993436,42 29.6470588,42 L7,42 C6.44771525,42 6,41.5522847 6,41 L6,8 C6,7.44771525 6.44771525,7 7,7 L29.6470588,7 C30.1993436,7 30.6470588,7.44771525 30.6470588,8 L30.6470588,23.5 Z M30.6511765,23.5 L39.5888288,23.5 L35.1157921,19.0189757 C34.7256164,18.6281032 34.7261812,17.9949385 35.1170537,17.6047627 C35.5079262,17.214587 36.1410909,17.2151518 36.5312667,17.6060243 L42.7077373,23.7935243 C43.0974209,24.1839038 43.0974209,24.8160962 42.7077373,25.2064757 L36.5312667,31.3939757 C36.1410909,31.7848482 35.5079262,31.785413 35.1170537,31.3952373 C34.7261812,31.0050615 34.7256164,30.3718968 35.1157921,29.9810243 L39.5888288,25.5 L30.6511765,25.5 L30.6511765,23.5 Z",
    id: "Combined-Shape",
    fill: "#0A1428",
    fillRule: "nonzero"
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgExit, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/exit.83f5aed6.svg";
export { ForwardRef as ReactComponent };